import MarkdownContent from 'src/features/product/product-detail/ui/updates-tab/markdown-content/MarkdownContent';
import isFileImage from 'src/features/product/product-detail/utils/isFileImage';
import { AiIcon } from 'src/shared/components';
import { Timeline } from 'src/shared/types/timeline';

import FileAttachment from 'src/shared/components/FileAttachment';
import ImageGallery from 'src/shared/components/ImageGallery';

interface TimelineClientMessageProps {
  stage: Timeline;
}

/** A timeline stage's message to the client, with the files sent with it. */
const TimelineClientMessage: React.FC<TimelineClientMessageProps> = ({
  stage
}) => {
  const files = stage.client_files ?? [];
  const images = files.filter((file) => isFileImage(file));
  const otherFiles = files.filter((file) => !isFileImage(file));

  return (
    <div className="p-3 bg-gray-2 rounded-xl flex gap-2 items-start">
      <AiIcon isColored />
      <div className="flex flex-col gap-2 min-w-0">
        <MarkdownContent
          markdownString={stage.client_notes ?? ''}
          className="text-secondary-text"
        />
        {images.length > 0 && (
          <ImageGallery
            imageUrls={images.map((file) => ({
              url: file.url,
              name: file.name,
              description: file.description
            }))}
          />
        )}
        {otherFiles.length > 0 && (
          <div className="flex flex-wrap gap-2">
            {otherFiles.map((file) => (
              <FileAttachment
                key={file.id}
                fileUrl={file.url}
                fileName={file.name}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default TimelineClientMessage;
